import { PreviewDialogProps, ImageCropRef } from '../types';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, Menu, MenuItem, ListItemText } from '@mui/material';
import ImageCrop from './ImageCrop';
import 'react-image-crop/dist/ReactCrop.css';
import { useState, useRef } from 'react';

// todo FIX THIS
const PreviewDialog = (props: PreviewDialogProps) => {
    const { open, onClose, onUpdate, file, aspectRatio, editMode, isReadOnly, setEditMode } = props;
    // const [editMode, setEditMode] = useState(false);
    const aspectRatioList = [
        { id: 1, label: 'Landscape (16/9)', value: 16 / 9 },
        { id: 2, label: 'Portrait (4/5)', value: 4 / 5 },
        { id: 3, label: 'Square (1/1)', value: 1 },
        { id: 4, label: 'A4 (21/29.7)', value: 21 / 29.7 },
        { id: 5, label: 'A3 (29.7/42)', value: 29.7 / 42 },
        { id: 6, label: 'A2 (42/59.4)', value: 42 / 59.4 },
        { id: 7, label: 'A1 (59.4/84.1)', value: 59.4 / 84.1 },
        { id: 8, label: 'A0 (84.1/118.9)', value: 84.1 / 118.9 },
        { id: 9, label: 'Free', value: undefined }
    ];
    const [selectedId, setSelectedId] = useState<number>(2);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const openArMenu = Boolean(anchorEl);
    const imageCropRef = useRef<ImageCropRef>(null);

    const handleClose = () => {
        setEditMode(false);
        onClose();
    };

    const handleUpdate = (updatedFile: File) => {
        onUpdate && onUpdate({ ...file, fileObject: updatedFile });
    };

    const handleSave = () => {
        if (imageCropRef.current?.handleSave()) setEditMode(false);
    };

    const handleSelectAspectRatio = (value: number | undefined, id: number) => {
        setSelectedId(id);
        setAnchorEl(null);
        imageCropRef.current?.setAspectRatio(value);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth={file.fileObject?.type.startsWith('image/') ? 'md' : 'lg'} fullWidth>
            <DialogTitle>
                <Typography variant="h6">{file?.name}</Typography>
            </DialogTitle>
            <DialogContent
                sx={{
                    display: 'flex',
                    height: '75vh',
                    padding: 0
                }}
            >
                {file.fileObject?.type.startsWith('image/') && (
                    <ImageCrop
                        src={file?.fileObject ?? ''}
                        editMode={editMode}
                        onCrop={handleUpdate}
                        ref={imageCropRef}
                        fixedAspectRatio={aspectRatio}
                    />
                )}
                {file.fileObject?.type.startsWith('application/pdf') && (
                    <iframe src={URL.createObjectURL(file.fileObject)} title={file.name} width="100%" height="100%" />
                )}
            </DialogContent>
            <DialogActions>
                {editMode && (
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        sx={{
                            background: '#4d79bc',
                            color: '#fff',
                            ':hover': {
                                background: '#79AEC9',
                                color: '#fff'
                            }
                        }}
                    >
                        Save
                    </Button>
                )}
                {editMode && (
                    <Button
                        variant="contained"
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        sx={{
                            background: '#4d79bc',
                            color: '#fff',
                            ':hover': {
                                background: '#79AEC9',
                                color: '#fff'
                            }
                        }}
                    >
                        Aspect Ratio
                    </Button>
                )}
                {editMode && (
                    <Button
                        variant="contained"
                        onClick={() => setEditMode(!editMode)}
                        sx={{
                            background: '#c42c0e',
                            color: '#fff',
                            ':hover': { background: '#c9807d', color: '#fff' }
                        }}
                    >
                        Cancel
                    </Button>
                )}
                {!editMode && !isReadOnly && file.fileObject?.type.startsWith('image') && (
                    <Button
                        variant="contained"
                        onClick={() => setEditMode(!editMode)}
                        sx={{
                            background: '#4d79bc',
                            color: '#fff',
                            ':hover': {
                                background: '#79AEC9',
                                color: '#fff'
                            }
                        }}
                    >
                        Edit
                    </Button>
                )}
                <Button
                    variant="contained"
                    onClick={handleClose}
                    sx={{
                        background: '#c42c0e',
                        color: '#fff',
                        ':hover': { background: '#c9807d', color: '#fff' }
                    }}
                >
                    Close
                </Button>
            </DialogActions>
            <Menu anchorEl={anchorEl} open={openArMenu} onClose={() => setAnchorEl(null)}>
                    {aspectRatioList.map((item) => (
                        <MenuItem
                            key={item.id}
                            onClick={() => handleSelectAspectRatio(item?.value, item.id)}
                            sx={{
                                background: selectedId === item.id ? '#4d79bc' : ''
                            }}
                        >
                            <ListItemText primary={item.label} />
                        </MenuItem>
                    ))}
                </Menu>
        </Dialog>
    );
};

export default PreviewDialog;
